<field-html-readonly *ngIf="field.readonly; else editable" [field]="field"></field-html-readonly>
<ng-template #editable>
  <field-html-single *ngIf="!field.multiple" [formGroup]="formGroup" [field]="field"></field-html-single>
</ng-template>
